import { Component, Element, Event, EventEmitter, h, Host, Prop, Watch } from '@stencil/core';
import { HTMLAnchorElementTarget } from '../../utils/helpers';

@Component({
  tag: 'vds-submenu-navitem',
  styleUrl: 'vds-submenu-navitem.scss',
  shadow: true,
})
export class VdsSubmenuNavitem {

  @Element() el!: HTMLVdsSubmenuNavitemElement;

  /**
   * Specifies the URL of the page the link goes to
   */
  @Prop() href: string;

  /**
   * Specifies where to open the linked document
   */
  @Prop() target: HTMLAnchorElementTarget = '_self';

  /**
   * Sets the download attribute for the underlying anchor element
   */
  @Prop() download: boolean = false;

  /**
   * Applies highlight and arrow decoration
   */
  @Prop({ mutable: true, reflect: true }) active: boolean = false;

  /**
   * Changes the size of the link
   */
  @Prop({ mutable: true, reflect: true }) first: boolean = false;

  /**
   * Emitted event when the active state has changed
   */
  @Event({ cancelable: true }) vdsActive: EventEmitter<boolean>;

  @Watch('active')
  protected activeChanged() {
    if (this.active) this.vdsActive.emit(this.active);
  }

  render() {
    const { href, target, active, first } = this;

    return (
      <Host>
        <a ref={ref => this.setAttributes(ref)}
           href={href}
           target={target}
           class={{
             'active': active,
             'first': first
           }}
           onMouseEnter={() => this.active = true}>

           <slot></slot>

          { target !== '_blank' && active && this.renderInternalSVG() }

          { target == '_blank' && this.renderExternalSVG() }

        </a>
      </Host>
    );
  }

  private setAttributes(el: HTMLAnchorElement): void {
    if (this.download) {
      el.setAttribute('download', '');
    }
  }

  private renderInternalSVG() {
    return (
      <svg viewBox="59 54 9.97 20" height="18" class={{
        'inline-flex relative': true,
        'top-[5px]': this.first,
        'top-[3px]': !this.first
      }}>
        <path d="M60,73l7-7a2.54,2.54,0,0,0,0-4l-7-7" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
      </svg>
    )
  }

  private renderExternalSVG() {
    return (
      <svg data-name="2px_Line_Icons" viewBox="44 43.99 40.01 40.01" width="14" height="14" class={{
        'inline-flex relative text-berry': true,
        'top-[5px]': this.first,
        'top-[3px]': !this.first
      }}>
        <path d="M71,45h9.15a2.76,2.76,0,0,1,2.12.73A2.72,2.72,0,0,1,83,47.85V57m-5-7L61,67m0-17s-5.75,0-8,0-4.22.31-6,2-2,3.71-2,6c0,2.07,0,15.36,0,17,0,2.25.31,4.22,2,6s3.71,2,6,2c2,0,15,0,17,0,2.25,0,4.22-.31,6-2s2-3.71,2-6c0-1.64,0-8,0-8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
      </svg>
    )
  }

}
